import {
    Box,
    Button,
    ButtonBase,
    Card,
    CardContent,
    FormControl,
    Input,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    Typography
} from '@material-ui/core';
import {
    Add,
    ClearAll,
    DeleteForeverOutlined,
    EditOutlined,
    ExpandLess,
    ExpandMore,
    Search
} from '@material-ui/icons';
import api from 'services/api';
import { ANAO, ASIM } from 'consts';
import { Link } from 'react-router-dom';
import React, { Component } from 'react';
import { safeSetState } from 'lib/reactUtils';
import { Autocomplete } from '@material-ui/lab';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { AlertInformation, DeleteConfirmationModal } from 'components';

const ESTILO_PAGINA = {
    marginLeft: 30,
    marginTop: 30,
    marginRight: 30
};

const ESTILO_CABECALHO = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff',
    padding: '10px 16px',
    borderRadius: '8px 8px 0 0',
    boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)'
};

const ESTILO_ADD_BUTTON = {
    height: 42,
    display: 'flex',
    alignItems: 'center',
    float: 'right',
    marginTop: 3,
    marginRight: 3
};

const ESTILO_ICONE_ACAO = {
    cursor: 'pointer',
    marginRight: 10
};

const ESTILO_TEXTO_VERMELHO = {
    color: 'red'
};

const ESTILO_COLUNA_CODIGO = {
    width: '10%'
};

const ESTILO_COLUNA_MENSAGEM = {
    width: '70%',
    maxWidth: '70%'
};

class GrupoMsgWhatsAppFornecedorList extends Component {
    state = {
        gruposmensagem: [],
        searchFilter: {
            nomeGrupoMensagem: '',
            situacaoInativoFilter: ANAO
        },
        gruposAbertos: [],
        listaMensagens: [],
        groupSelectedAddMessage: 0,
        selectedValue: null,
        inputValue: '',
        openAlert: false,
        messageAlert: '',
        openDeleteGrupoConfirmation: false,
        selectedGrupo: null
    };

    _isMounted = false;
    inputRef = React.createRef();
    safeSetState = safeSetState;

    /* Carrega os dados iniciais da tela */
    componentDidMount() {
        this._isMounted = true;
        this.loadGruposMensagens();
        this.loadListaMensagens();
    };

    /* Evita atualizar o state após sair da tela */
    componentWillUnmount() {
        this._isMounted = false;
    };

    /* Carrega os grupos de mensagens */
    loadGruposMensagens = async () => {
        const { searchFilter } = this.state;
        const { nomeGrupoMensagem, situacaoInativoFilter } = searchFilter;

        let active = '';
        let params = '';

        if (situacaoInativoFilter === ANAO) {
            active = '/active/true';
        } else if (situacaoInativoFilter === ASIM) {
            active = '/active/false';
        }

        // consulta pelo nome do grupo
        if (nomeGrupoMensagem) {
            params = `?tbgrupomsgwhatsfornecedor.nome=_like_${nomeGrupoMensagem}`;
        }

        try {
            const response = await api.get(`/whatsapp/grupomensagemfornecedor${active}${params}`);

            this.safeSetState({
                gruposmensagem: response.data,
                gruposAbertos: []
            });
        } catch (error) {
            console.error('Erro ao carregar os grupos de mensagens:', error);

            this.safeSetState({
                gruposmensagem: [],
                gruposAbertos: []
            });
        }
    };

    /* Carrega as mensagens ativas para inserir nos grupos */
    loadListaMensagens = async () => {
        try {
            const response = await api.get('/whatsapp/mensagemfornecedor/active/true');

            const listaMensagens = response.data.map(mensagem => ({
                idmsgwhats: mensagem.idmsgwhats,
                descricao: mensagem.descricao
            }));

            this.safeSetState({ listaMensagens });
        } catch (error) {
            console.error('Erro ao carregar as mensagens:', error);
        }
    };

    /* Pesquisa os filtros na tela */
    onChangeSearch = (event) => {
        const { name, value } = event.target;

        const searchFilter = {
            ...this.state.searchFilter,
            [name]: value.toUpperCase()
        };

        this.setState({
            searchFilter,
            groupSelectedAddMessage: 0
        }, () => {
            if (name === 'situacaoInativoFilter') {
                this.loadGruposMensagens();
            }
        });
    };

    /* Limpa os filtros da tela */
    limpaFiltros = () => {
        const searchFilter = {
            nomeGrupoMensagem: '',
            situacaoInativoFilter: ANAO
        };

        this.setState({ searchFilter });
    };

    /* Abre a janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({
            openAlert: true,
            messageAlert: message
        });
    };

    /* Fecha a janela de mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    /* Alterna entre expandir e recolher os grupos */
    toggleGrupo = (id) => {
        const { gruposAbertos } = this.state;

        this.setState({
            gruposAbertos: gruposAbertos.includes(id)
                ? gruposAbertos.filter(grupoId => grupoId !== id)
                : [...gruposAbertos, id],
            groupSelectedAddMessage: 0
        });
    };

    /* Abre a janela de confirmação para a exclusão */
    handleOpenDeleteGrupoConfirmation = (codgrupomensagem) => {
        this.setState({
            openDeleteGrupoConfirmation: true,
            selectedGrupo: codgrupomensagem
        });
    };

    /* Fecha a janela de confirmação da exclusão */
    handleCloseDeleteGrupoConfirmation = () => {
        this.setState({ openDeleteGrupoConfirmation: false });
    };

    /* Deleta o grupo */
    handleDeleteGrupo = async (id) => {
        try {
            const response = await api.delete(`/whatsapp/grupomensagemfornecedor/${id}`);

            // verifica se a exclusão foi bem-sucedida
            if (response.status === 200) {
                this.handleCloseDeleteGrupoConfirmation();
                this.loadGruposMensagens();
            }
        } catch (error) {
            this.handleCloseDeleteGrupoConfirmation();

            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao excluir o grupo!'
            );
        }
    };

    /* Confirma a exclusão */
    handleConfirmDelete = () => {
        const { selectedGrupo } = this.state;

        this.handleDeleteGrupo(selectedGrupo);
    };

    /* Abre o campo para inserir mensagem no grupo */
    handleAddMensagem = (idgrupo) => {
        this.setState({ groupSelectedAddMessage: idgrupo });
    };

    /* Adiciona a mensagem ao grupo */
    handleAdicionarMensagemAoGrupo = (idgrupo, mensagem) => {
        const { gruposmensagem } = this.state;
        const grupo = gruposmensagem.find(g => g.idgrupomsgwhats === idgrupo);

        if (!grupo) return;

        const jaExiste = grupo.mensagens.some(
            m => m.idmsgwhats === mensagem.idmsgwhats
        );

        if (jaExiste) return;

        this.insereMensagemGrupo(idgrupo, mensagem.idmsgwhats);

        this.setState({
            gruposmensagem: gruposmensagem.map(g => (g === grupo) ? {
                ...g,
                mensagens: [
                    ...g.mensagens,
                    {
                        idmsgwhats: mensagem.idmsgwhats,
                        descricao: mensagem.descricao
                    }
                ]
            } : g)
        });
    };

    /* Insere a mensagem no grupo */
    insereMensagemGrupo = async (idgrupomsgwhats, idmsgwhats) => {
        try {
            await api.post('/whatsapp/mensagemgrupofornecedor', {
                idgrupomsgwhats,
                idmsgwhats
            });
        } catch (error) {
            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao inserir a mensagem no grupo!'
            );
        }
    };

    /* Remove a mensagem do grupo */
    handleDeleteMensagemGrupo = async (idgrupo, idmsgwhats) => {
        try {
            const response = await api.delete(
                `/whatsapp/mensagemgrupofornecedor/${idgrupo}/${idmsgwhats}`
            );

            if (response.status === 200) {
                this.setState(prevState => ({
                    gruposmensagem: prevState.gruposmensagem.map(grupo => (
                        (grupo.idgrupomsgwhats === idgrupo) ? {
                            ...grupo,
                            mensagens: grupo.mensagens.filter(
                                mensagem => mensagem.idmsgwhats !== idmsgwhats
                            )
                        } : grupo
                    ))
                }));
            }
        } catch (error) {
            this.handleOpenAlert(
                error.response?.data?.error ||
                error.response?.data?.message ||
                'Erro ao remover a mensagem do grupo!'
            );
        }
    };

    /* Evento onInputChange do autocomplete de mensagens */
    onInputChangeMensagem = (event, newInputValue) => {
        this.setState({ inputValue: newInputValue });
    };

    /* Evento onChange do autocomplete de mensagens */
    onChangeMensagem = (idgrupo) => (event, newValue) => {
        if (!newValue) return;

        this.handleAdicionarMensagemAoGrupo(idgrupo, newValue);

        this.setState({
            selectedValue: null,
            inputValue: ''
        }, () => {
            if (this.inputRef.current) {
                this.inputRef.current.blur();
            }
        });
    };

    /* Retorna o campo de texto do autocomplete */
    renderInputMensagem = (params) => (
        <TextField
            {...params}
            inputRef={this.inputRef}
            label="Inserir mensagem"
            variant="standard"
            size="small"
            fullWidth
        />
    );

    /* Renderiza as mensagens do grupo */
    renderMensagens = (grupo) => {
        const { groupSelectedAddMessage, inputValue, listaMensagens, selectedValue } = this.state;

        return (
            <TableRow>
                <TableCell
                    colSpan={4}
                    style={{
                        paddingLeft: 50,
                        backgroundColor: '#f9f9f9'
                    }}
                >
                    <Table size="small">
                        <TableHead>
                            <TableRow>
                                <TableCell style={ESTILO_COLUNA_CODIGO}>
                                    Código
                                </TableCell>

                                <TableCell style={ESTILO_COLUNA_MENSAGEM}>
                                    Mensagem
                                </TableCell>

                                <TableCell>
                                    Ações
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {grupo.mensagens.map(msg => (
                                <TableRow key={msg.idmsgwhats}>
                                    <TableCell style={ESTILO_COLUNA_CODIGO}>
                                        {msg.idmsgwhats}
                                    </TableCell>

                                    <TableCell style={ESTILO_COLUNA_MENSAGEM}>
                                        {msg.descricao}
                                    </TableCell>

                                    <TableCell>
                                        <DeleteForeverOutlined
                                            onClick={() => this.handleDeleteMensagemGrupo(grupo.idgrupomsgwhats, msg.idmsgwhats)}
                                            style={ESTILO_ICONE_ACAO}
                                        />
                                    </TableCell>
                                </TableRow>
                            ))}

                            {(groupSelectedAddMessage === grupo.idgrupomsgwhats) && (
                                <TableRow>
                                    <TableCell
                                        style={ESTILO_COLUNA_CODIGO}
                                    />

                                    <TableCell style={ESTILO_COLUNA_MENSAGEM}>
                                        <div
                                            style={{
                                                width: '100%',
                                                maxWidth: 300
                                            }}
                                        >
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    options={listaMensagens}
                                                    getOptionLabel={(option) => option.descricao || ''}
                                                    value={selectedValue}
                                                    inputValue={inputValue}
                                                    onInputChange={this.onInputChangeMensagem}
                                                    onChange={this.onChangeMensagem(grupo.idgrupomsgwhats)}
                                                    renderInput={this.renderInputMensagem}
                                                    disableClearable={false}
                                                />
                                            </FormControl>
                                        </div>
                                    </TableCell>

                                    <TableCell />
                                </TableRow>
                            )}

                            <TableRow>
                                <TableCell
                                    colSpan={3}
                                    style={{
                                        padding: '0',
                                        width: '100%',
                                        backgroundColor: '#ffffff'
                                    }}
                                >
                                    <ButtonBase
                                        onClick={() => this.handleAddMensagem(grupo.idgrupomsgwhats)}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            padding: '0',
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center'
                                        }}
                                    >
                                        <Add
                                            fontSize="small"
                                            color="primary"
                                        />
                                    </ButtonBase>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableCell>
            </TableRow>
        );
    };

    /* Renderiza o grupo e suas mensagens */
    renderGrupo = (grupo) => {
        const { gruposAbertos } = this.state;

        const aberto = gruposAbertos.includes(grupo.idgrupomsgwhats);
        const estiloTexto = (grupo.inativo === ASIM) ? ESTILO_TEXTO_VERMELHO : {};

        return (
            <React.Fragment key={grupo.idgrupomsgwhats}>
                <TableRow hover>
                    <TableCell style={estiloTexto}>
                        {grupo.idgrupomsgwhats}
                    </TableCell>

                    <TableCell style={estiloTexto}>
                        {grupo.nome}
                    </TableCell>

                    <TableCell>
                        <Link to={`/crm/grupomsgwhatsappfornecedor/${grupo.idgrupomsgwhats}`}>
                            <EditOutlined
                                style={ESTILO_ICONE_ACAO}
                            />
                        </Link>

                        <DeleteForeverOutlined
                            onClick={() => this.handleOpenDeleteGrupoConfirmation(grupo.idgrupomsgwhats)}
                            style={ESTILO_ICONE_ACAO}
                        />
                    </TableCell>

                    <TableCell align="right">
                        <Button onClick={() => this.toggleGrupo(grupo.idgrupomsgwhats)}>
                            {aberto ? <ExpandLess /> : <ExpandMore />}
                        </Button>
                    </TableCell>
                </TableRow>

                {(aberto && grupo.mensagens) && this.renderMensagens(grupo)}
            </React.Fragment>
        );
    };

    render() {
        const {
            gruposmensagem,
            messageAlert,
            openAlert,
            openDeleteGrupoConfirmation,
            searchFilter,
            selectedGrupo
        } = this.state;

        return (
            <div style={ESTILO_PAGINA}>
                <div>
                    <Box style={ESTILO_CABECALHO}>
                        <Typography
                            variant="h4"
                            style={{
                                fontWeight: 600,
                                letterSpacing: 0.5
                            }}
                        >
                            GRUPOS DE MENSAGENS
                        </Typography>

                        <Box
                            style={{
                                display: 'flex',
                                gap: 10
                            }}
                        >
                            <Button
                                component={Link}
                                to="/crm/msgwhatsappfornecedor"
                                variant="contained"
                                color="primary"
                                style={ESTILO_ADD_BUTTON}
                            >
                                Mensagens
                            </Button>

                            <Button
                                component={Link}
                                to="/crm/grupomsgwhatsappfornecedor/novo"
                                variant="contained"
                                color="primary"
                                style={ESTILO_ADD_BUTTON}
                            >
                                Novo Grupo
                            </Button>
                        </Box>
                    </Box>

                    <Paper
                        style={{
                            marginBottom: 10,
                            marginTop: 10,
                            padding: 10
                        }}
                    >
                        <Box
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 5
                            }}
                        >
                            <Input
                                autoFocus
                                id="nomeGrupoMensagem"
                                name="nomeGrupoMensagem"
                                onChange={this.onChangeSearch}
                                placeholder="Nome grupo de mensagem a pesquisar"
                                style={{ width: 300 }}
                                value={searchFilter.nomeGrupoMensagem}
                            />

                            <Select
                                id="situacaoInativoFilter"
                                name="situacaoInativoFilter"
                                value={searchFilter.situacaoInativoFilter || ''}
                                onChange={this.onChangeSearch}
                            >
                                <MenuItem value={ANAO}>
                                    Ativos
                                </MenuItem>

                                <MenuItem value={ASIM}>
                                    Inativos
                                </MenuItem>

                                <MenuItem value={'T'}>
                                    Todos
                                </MenuItem>
                            </Select>

                            <Button
                                id="pesquisar"
                                color="primary"
                                onClick={this.loadGruposMensagens}
                            >
                                <Search />
                            </Button>

                            <Button
                                color="primary"
                                onClick={this.limpaFiltros}
                            >
                                <ClearAll />
                            </Button>
                        </Box>
                    </Paper>

                    <Card>
                        <CardContent>
                            <PerfectScrollbar>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell
                                                style={{
                                                    width: 100,
                                                    maxWidth: 100
                                                }}
                                            >
                                                Código
                                            </TableCell>

                                            <TableCell>
                                                Grupo
                                            </TableCell>

                                            <TableCell>
                                                Ações
                                            </TableCell>

                                            <TableCell
                                                align="right"
                                            />
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {gruposmensagem.map(this.renderGrupo)}
                                    </TableBody>
                                </Table>
                            </PerfectScrollbar>
                        </CardContent>
                    </Card>
                </div>

                <div>
                    <AlertInformation
                        open={openAlert}
                        message={messageAlert}
                        handleClose={this.handleCloseAlert}
                    />

                    <DeleteConfirmationModal
                        open={openDeleteGrupoConfirmation}
                        itemId={selectedGrupo}
                        message={`Confirma exclusão do grupo ${selectedGrupo}?`}
                        handleClose={this.handleCloseDeleteGrupoConfirmation}
                        handleDelete={this.handleConfirmDelete}
                    />
                </div>
            </div>
        );
    }
};

export default GrupoMsgWhatsAppFornecedorList;